import { useState } from 'react';
import { submitTakeItDownReport } from '@genfun/core/api/API';
import { Footer } from '../components/Footer';
import './TakeItDownReport.css';

const SITE_NAME = 'MAKEPORN';
const ISSUE_LINE = `${SITE_NAME} — ISSUE 01 / 2026`;
const SUPPORT_EMAIL = 'support@makeporn.art';

function BackArrow() {
    return (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
            <line x1="19" y1="12" x2="5" y2="12"/>
            <polyline points="12 19 5 12 12 5"/>
        </svg>
    );
}

export function TakeItDownReport({ onNavigate, mediaId: mediaIdProp }) {
    const mediaId = mediaIdProp || new URLSearchParams(window.location.search).get('media_id') || '';
    const hasMediaId = !!mediaId;

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [url, setUrl] = useState('');
    const [description, setDescription] = useState('');
    const [confirmed, setConfirmed] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(null);

    const goHome = () => onNavigate('video');

    const targetFilled = hasMediaId ? true : !!url.trim();
    const canSubmit = name.trim() && email.trim() && targetFilled && description.trim() && confirmed && !submitting;

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!canSubmit) return;
        setError(null);
        setSubmitting(true);
        try {
            const [data, status] = await submitTakeItDownReport({
                name: name.trim(),
                email: email.trim(),
                description: description.trim(),
                ...(hasMediaId ? { media_id: mediaId } : { url: url.trim() }),
            });
            if (status >= 200 && status < 300) {
                setSubmitted(true);
            } else if (status === 429) {
                setError('Too many requests. Please try again in a few minutes.');
            } else if (status === 400 && data?.detail) {
                setError(data.detail);
            } else {
                setError('Could not submit the request. Please try again later.');
            }
        } catch (err) {
            setError('Network error. Please check your connection and try again.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="tida-root">
            <header className="tida-mast">
                <div className="tida-mast-inner">
                    <div className="tida-mast-id" onClick={goHome}>
                        <strong>{SITE_NAME}</strong>
                        <span>— TAKE IT DOWN</span>
                    </div>
                    <button className="tida-back-btn" onClick={goHome}>
                        <BackArrow /> Back
                    </button>
                </div>
            </header>

            <main className="tida-main">
                <div className="tida-head">
                    <div className="tida-kicker">№ 09 / Removal request</div>
                    <h1 className="tida-title">Content removal request</h1>
                    <p className="tida-lede">
                        Under the TAKE IT DOWN Act (TIDA), you may request removal of nonconsensual
                        intimate visual depictions. We will process your request within 48 hours.
                    </p>
                </div>

                {submitted ? (
                    <div className="tida-success">
                        <h2>Request received</h2>
                        <p>
                            Thanks — your removal request has been sent to our team. We will review it
                            and respond within 48 hours at the email address you provided.
                        </p>
                        <button className="tida-back-btn" onClick={goHome}>
                            <BackArrow /> Back
                        </button>
                    </div>
                ) : (
                    <form className="tida-form" onSubmit={onSubmit} noValidate>
                        <label className="tida-field">
                            <span className="tida-label">Your full name</span>
                            <input
                                type="text"
                                className="tida-input"
                                placeholder="Jane Smith"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                            />
                        </label>

                        <label className="tida-field">
                            <span className="tida-label">Email address</span>
                            <input
                                type="email"
                                className="tida-input"
                                placeholder="you@example.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </label>

                        {hasMediaId ? (
                            <div className="tida-field">
                                <span className="tida-label">Reporting gallery item</span>
                                <div className="tida-pinned">
                                    <span className="tida-pinned-label">media_id</span>
                                    <code className="tida-pinned-value">{mediaId}</code>
                                </div>
                                <span className="tida-help">
                                    Selected from the gallery — the team will look up this item directly.
                                </span>
                            </div>
                        ) : (
                            <label className="tida-field">
                                <span className="tida-label">URL(s) of the content to be removed</span>
                                <textarea
                                    className="tida-input tida-textarea"
                                    placeholder="https://makeporn.art/..."
                                    value={url}
                                    onChange={(e) => setUrl(e.target.value)}
                                    rows={4}
                                    required
                                />
                                <span className="tida-help">Paste one URL per line</span>
                            </label>
                        )}

                        <label className="tida-field">
                            <span className="tida-label">Describe the content and why you are requesting removal</span>
                            <textarea
                                className="tida-input tida-textarea"
                                placeholder="Please describe the content and explain why it should be removed..."
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                rows={6}
                                required
                            />
                        </label>

                        <label className="tida-confirm">
                            <input
                                type="checkbox"
                                checked={confirmed}
                                onChange={(e) => setConfirmed(e.target.checked)}
                            />
                            <span>
                                I confirm that the information provided is accurate and that I am the
                                person depicted or their authorized representative.
                            </span>
                        </label>

                        {error && <div className="tida-error">{error}</div>}

                        <button type="submit" className="tida-submit" disabled={!canSubmit}>
                            {submitting ? 'Submitting…' : 'Submit removal request'}
                        </button>
                    </form>
                )}
            </main>

            <footer className="tida-foot">
                <div className="tida-foot-inner">
                    <div className="tida-foot-id">{ISSUE_LINE}</div>
                    <div className="tida-foot-copy">
                        We will respond within 48 hours · Questions?{' '}
                        <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
                    </div>
                </div>
            </footer>

            <Footer onNavigate={onNavigate} />
        </div>
    );
}
